<h3 *ngIf="title">{{ title }}</h3>
<div class="workflow d-flex">
  <ng-content></ng-content>
</div>